import * as React from "react";
import PhoneNumberDisplay from "../../../components/PhoneNumberDisplay";
import { FamilyMemberSms, Page } from "../../types";
import { Link } from "react-router-dom";

type Props = {
  patientId: string;
  familyMembers: Page<FamilyMemberSms> | null;
  allowMany: boolean;
  setFamilyMembers: (familyMembers: Page<FamilyMemberSms>) => void;
};

const SelectFamilyMembers: React.FunctionComponent<Props> = ({
  patientId,
  familyMembers,
  allowMany,
  setFamilyMembers
}: Props) => {
  const handeCheckboxClick = (index: number) => {
    if (!familyMembers) return;
    if (allowMany) {
      const newList: FamilyMemberSms[] = familyMembers?.results.map((item, idx) => {
        if (idx === index) {
          const updatedItem = {
            ...item,
            ischecked: !item.ischecked
          };

          return updatedItem;
        }

        return item;
      });

      setFamilyMembers({
        count: familyMembers.count,
        next: familyMembers.next,
        previous: familyMembers.previous,
        results: newList
      });
    } else {
      const newList: FamilyMemberSms[] = familyMembers?.results.map((item, idx) => {
        const updatedItem = {
          ...item,
          ischecked: idx === index ? !item.ischecked : false
        };

        return updatedItem;
      });

      setFamilyMembers({
        count: familyMembers.count,
        next: familyMembers.next,
        previous: familyMembers.previous,
        results: newList
      });
    }
  };
  return (
    <>
      {familyMembers && familyMembers.results.length === 0 && (
        <>
          <div>This patient has no family members assigned.</div>
          <div className="mt-10 flex-center">
            Go{" "}
            <Link to={`/patient/${patientId}/`}>
              <div className="hyperlink ml-5 mr-5" role="button" tabIndex={0}>
                here
              </div>
            </Link>{" "}
            to add family members.
          </div>
        </>
      )}
      {familyMembers && familyMembers.results.length > 0 && (
        <>
          <div className="bold">Please select the family member to invite.</div>
          {!allowMany && (
            <div>
              <small>* Ability to add many family members will be coming soon.</small>
            </div>
          )}

          <div className="mt-20 mb-30">
            <div className="flex family-header">
              <div className="flex-1">Relation</div>
              <div className="flex-1">Name</div>
              <div className="flex-1">Phone Number</div>
              <div className="sms-action">Include</div>
            </div>

            <div>
              {familyMembers?.results.map((member, index) => (
                <div key={index} className="mt-10">
                  <div className="flex full-width">
                    <div className="flex-1">{member.relation}</div>
                    <div className="flex-1 pl-5 pr-5">{member.name}</div>
                    <div className="flex-1">
                      <PhoneNumberDisplay phonenumber={member.phone} />
                    </div>
                    <div className="sms-action">
                      <input
                        id="inActive"
                        type="checkbox"
                        className="inactive-checkbox"
                        checked={!!member.ischecked}
                        onChange={() => handeCheckboxClick(index)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default SelectFamilyMembers;
